import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { faArrowUpRightFromSquare, faCalendarDays } from '@fortawesome/pro-regular-svg-icons';
import { TopazDialogMaxSize } from '@pearsonvue/topaz-angular-ui';
import { AnnouncementDialogueComponent } from './announcement-dialogue/announcement-dialogue.component';
import { SppdashboardService } from 'src/app/view/dashboard/sppdashboard.service';
import { LiveComponent } from '../live/live.component';
import { TestOutFailModalComponent } from 'src/app/component/test-out-fail-modal/test-out-fail-modal.component';
@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnDestroy {
  username: any = '';
  anouncementCount: number = 0;
  icons = {
    faArrowUpRightFromSquare,
    faCalendarDays
  }
  // using test data
  announcements: any;
  status: any;
  isHomePageLoading: boolean = true;
  isPayDisabled: boolean = false;
  emailp: any;
  showBanner: boolean | undefined = undefined;
  isLoadingBannerStatus: boolean = true;
  private statusCheckInterval: any;
  marketplaceLink: any;
  istestOutFailureTriggred: boolean = false;
  isDowntime: boolean = false;
  downTimeMessage: string = '';
  previousStatus: string = '';
  isSessionListBtn: boolean = false;
  private isHomeStatusReady = false;
  private areHomeAnnouncementsReady = false;
  private isHomeDowntimeReady = false;

  constructor(
    private router: Router,
    private _dialog: MatDialog,
    private sppdashboardService: SppdashboardService,
    private _live: LiveComponent,
  ) { }

  ngOnInit(): void {
    this.getDowntimeStatus();
    this.username = sessionStorage.getItem('firstname') == "null" ? '' : sessionStorage.getItem('firstname');
    this.emailp = sessionStorage.getItem('email');
    this.sppdashboardService.getUser().subscribe((res: any) => {
      this.sppdashboardService.marketplacelink(res?.data.country, res?.data.language).subscribe(
        (resp: any) => {
          this.marketplaceLink = resp?.data;
        })
      this._live.changeLink(res?.data);
      this.status = res?.data?.status;
      this.previousStatus = res?.data?.previousStatus || '';
      this.isHomeStatusReady = true;
      this.updateHomePageLoading();
      this.isSessionListBtn = (this.previousStatus === 'RENEWAL' && (this.status === 'TEST_OUT_FAIL' || this.status === 'ILT_FAIL')) ? true : false;

      if (this.status === 'TEST_OUT_FAIL' && !this.istestOutFailureTriggred) {
        this.triggerTestOutFailureModal();
        this.istestOutFailureTriggred = true;
      }


      this.checkPaymentStatus();
      // this.updateBanner();
      this.fetchAnnouncements();
    }, () => {
      this.isHomeStatusReady = true;
      this.areHomeAnnouncementsReady = true;
      this.updateHomePageLoading();
    })

    this.statusCheckInterval = setInterval(() => {
      this.sppdashboardService.getUser().subscribe((res: any) => {
        this._live.changeLink(res?.data);
        this.status = res?.data?.status;
        this.previousStatus = res?.data?.previousStatus || '';
          setTimeout(() => {
          const bannerDiv = document.querySelector('[data-test="banner"]');
          if (bannerDiv && bannerDiv.getAttribute('tabindex') === '0') {
            bannerDiv.setAttribute('tabindex', '-1');
          }
        }, 0);
        this.checkPaymentStatus();
        // this.updateBanner();
      })
    }, 10000);

  }


  getDowntimeStatus = () => {
    this.sppdashboardService.getDowntimeStatus().subscribe((res: any) => {
      if(res?.data?.enabled){
         this.isDowntime = res?.data?.enabled || false;
        this.downTimeMessage = res?.data?.messageText || '';
      } else {
        this.isDowntime = false;
        this.downTimeMessage = '';
      }
      this.isHomeDowntimeReady = true;
      this.updateHomePageLoading();
    }, (error) => {      
      this.isDowntime = false;
      this.downTimeMessage = '';
      this.isHomeDowntimeReady = true;
      this.updateHomePageLoading();
    });
  }

  private updateHomePageLoading(): void {
    this.isHomePageLoading = !(
      this.isHomeStatusReady &&
      this.areHomeAnnouncementsReady &&
      this.isHomeDowntimeReady
    );
  }

  triggerTestOutFailureModal() {
    const dialogRef = this._dialog.open(TestOutFailModalComponent, {
      maxWidth: TopazDialogMaxSize.SMALL,
      disableClose: true,
    });

     dialogRef.afterClosed().subscribe(result => {
      if (result) {
         this.istestOutFailureTriggred = true;
      }
    });
  }


  onClickPaynow() {
    this.router.navigate(['/live']);
  }

  navigateToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  public openAnnouncementDialog(announcement: any): void {
    const data = announcement;
    const dialogRef = this._dialog.open(AnnouncementDialogueComponent, {
      maxWidth: TopazDialogMaxSize.MEDIUM,
      data: data,
      id: 'mediumDialog'
    });

    dialogRef.afterClosed().subscribe((value) => {
      // Will log out "yes" or "no" based on the
      // mat-dialog-close attribute in the dialog template
    })
  }

  openAnnouncementPage() {
    this.router.navigate(['/announcement']);
  }

  checkPaymentStatus() {
    if (this.status === 'ACTIVE_MCT' || this.status === 'RENEWAL' || this.status === 'REINSTATE_SUBMIT' || this.status === 'RENEWAL_REJECT' || this.status === 'REINSTATE_REJECT' || this.status === 'EXPIRED') {
      this.isPayDisabled = false;
    }
    if (this.status === 'APPROVE' || this.status === 'REINSTATE_APPROVE' || this.status === 'RENEWAL_APPROVE') {
      this.isPayDisabled = true;
    }
  }

  fetchAnnouncements() {
    this.sppdashboardService.getAnnouncements('', true, 0, 10).subscribe((response: any) => {
      const content = response?.data?.result?.content || [];
      this.announcements = content.filter((item: any) => this.status === 'ALUMNI' ? item.announcementType === 'Alumni' : item.announcementType !== 'Alumni');
      this.anouncementCount = this.announcements.length;
      this.isLoadingBannerStatus = false;
      this.areHomeAnnouncementsReady = true;
      this.updateHomePageLoading();
    }, () => {
      this.announcements = [];
      this.anouncementCount = 0;
      this.isLoadingBannerStatus = false;
      this.areHomeAnnouncementsReady = true;
      this.updateHomePageLoading();
    });
  }

  
  closeDowntimeBanner(): void {
    this.isDowntime = false;
    this.downTimeMessage = '';
  }

  ngOnDestroy(): void {
    // Clear the interval when component is destroyed
    if (this.statusCheckInterval) {
      clearInterval(this.statusCheckInterval);
    }
  }

}
